import ver from '!!raw-loader!../../../../../embed-ver.txt';
import Script from 'next/script';
import { NextSeo } from 'next-seo';

import { isDev } from '@webapp/common/lib/const';
import { YaMetrikaCounter } from '@webapp/common/lib/metrics';
import { createEmbedUrl, createLandingUrl } from '@webapp/common/lib/utils';

const VERSION = String(ver).replace(/[\n\r]/g, '');

const Counters: VFC = () =>
    isDev ? null : <Script defer={true} dangerouslySetInnerHTML={{ __html: YaMetrikaCounter }} />;

const additionalLinkTags = [
    {
        rel: 'shortcut icon',
        href: '/favicon.ico?v=5',
    },
    {
        rel: 'apple-touch-icon',
        sizes: '180x180',
        href: '/apple-touch-icon.png?v=5',
    },
    {
        rel: 'icon',
        type: 'image/png',
        sizes: '32x32',
        href: '/favicon-32x32.png?v=5',
    },
    {
        rel: 'icon',
        type: 'image/png',
        sizes: '16x16',
        href: '/favicon-16x16.png?v=5',
    },
    {
        rel: 'manifest',
        href: '/site.webmanifest?v=5',
    },
    {
        rel: 'mask-icon',
        href: '/safari-pinned-tab.svg?v=5',
        color: '#318fff',
    },
    {
        rel: 'stylesheet',
        href: createEmbedUrl(`widget.css?v=${VERSION}`),
    },
];

export const Head: FC<{
    description?: string;
    keywords?: string;
    title?: string;
    url?: string;
}> = ({ description, keywords, title, url }) => {
    url = url && createLandingUrl(url);
    const canonical = (() => {
        try {
            const parts = new URL(url);
            return parts.origin + parts.pathname;
        } catch (e) {
            return null;
        }
    })();

    return (
        <>
            <Counters />
            <NextSeo
                additionalLinkTags={additionalLinkTags}
                canonical={canonical}
                defaultTitle='Testograf.ru'
                description={description}
                title={title}
                additionalMetaTags={[
                    {
                        name: 'copyright',
                        content: 'Copyright (c) Testograf ~ testograf.ru',
                    },
                    {
                        name: 'msvalidate.01',
                        content: '12C5AC434EB9D1FADC81D77B61EDDC7B',
                    },
                    {
                        name: 'wmail-verification',
                        content: '94239970d4baa3b0',
                    },
                    {
                        name: 'yandex-verification',
                        content: '66d4af105c6ff90f',
                    },
                    {
                        name: 'keywords',
                        content: keywords,
                    },
                    {
                        name: 'viewport',
                        content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0',
                    },
                    {
                        name: 'msapplication-TileColor',
                        content: '#318fff',
                    },
                    {
                        name: 'theme-color',
                        content: '#f3f3f3',
                    },
                ]}
                openGraph={{
                    type: 'website',
                    url,
                    description,
                    locale: 'ru_RU',
                    images: [
                        {
                            url: createLandingUrl('logo.png'),
                            width: 346,
                            height: 80,
                        },
                    ],
                }}
            />
            <Script src={createEmbedUrl(`widget.js?v=${VERSION}`)} strategy='beforeInteractive' />
        </>
    );
};
